export { ListGuiasEntrega } from "./list";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/entrega/list/index.tsx